<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="sp"> </p>
<section aria-labelledby="ch7" epub:type="chapter" role="doc-chapter">
<header>
<h1 class="Chap-Title-ct" id="ch7"><span aria-label="27" id="pg_27" role="doc-pagebreak"><span href="#/xhtml/contents#c_ch7" title="Link target outside of Sample">FBI COMMAND CENTER, QUANTICO, VA</span></span></h1>
</header>
<p class="CO">Once everyone left, Ezra clicked on his music and turned it up until the thumping bass vibrated the speakers in the small command center. He was usually stuck down at his desk in the open pit where all the analysts worked. But, since he was working on the task force, he had unfettered access to this room, which also just happened to have the best sound system at Quantico. Sometimes Ezra needed loud music to think and he hated using headphones so this was heaven.</p>
<p class="Text-Standard-tx">With the entire place to himself, he cranked the volume of some new Icelandic avant-garde band.</p>
<p class="Text-Standard-tx">As he swiveled the chair, Ezra’s prosthetics clacked against the table. Annoyed that they kept bonking the table legs, he decided to take them off. It was always a little bit of a relief to remove the hard prosthetic sockets and silicone socks capping his legs. Without the prosthetics in the way, he could use the desk chair to quickly slide along the edge of the conference table between stacks of files and three open laptops.</p>
<p class="Text-Standard-tx">The first laptop was just finishing up the database crawl trying to match the print they’d found on Jane Doe.</p>
<p class="Text-Standard-tx">“Negatory,” he said to himself over the wailing violins.</p>
<p class="Text-Standard-tx"><span aria-label="28" id="pg_28" role="doc-pagebreak">The next computer was scanning databases for any match to their unsub’s DNA. If he could identify their unknown subject, he could close the case tonight.</span></p>
<p class="Text-Standard-tx">“Also negatory,” Ezra said while the swelling drums of the song shook his chair as he slid to the last computer. He had written a program to crawl social media and public facial recognition databases with Jane Doe’s photo.</p>
<p class="Text-Standard-tx">A green box flashed on the screen. He’d found a match.</p>
<p class="Text-Standard-tx">The driving music suddenly dropped to a sparse rhythm that echoed around the room. Something about the haunting music filled Ezra with a sense of dread.</p>
<p class="Text-Standard-tx">He clicked on the flashing screen and he stared at the photo that popped up. The link led him to another photo, and another.</p>
<p class="Text-Standard-tx">“Oh my God,” he said softly as the ambient beat faded away.</p>
<p class="Text-Standard-tx">By the time he got to the last photo, his hands were shaking so badly he could barely dial Sayer’s number.</p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter7.vue?0ce5d07d